'use client';
import { removeReactNodes } from './removeReactNodes.js';

// FIXME: https://kaiten.s7.ru/space/84/card/551716
function serializeTheme(args) {
    return JSON.stringify(removeReactNodes(args));
}

export { serializeTheme };
//# sourceMappingURL=serializeTheme.js.map
